import { HMAC_SECRET_KEY, HMAC_TOKEN } from 'common/config';
import CryptoJS from 'crypto-js';
import moment from 'moment';

// Determine process type for POST requests
const getPostProcessType = (path, isSecLoan) => {
  if (path === 'loanpayment') return 'PROC_LOAN_PAY';
  return isSecLoan ? 'PROC_SEC_APP' : 'PROC_CRE_APP';
};

// Determine process type for PUT requests
const getPutProcessType = (path, body) => {
  if (path === 'disbursement') return 'PROC_DISB';
  if (path === 'disbursement-suplesi') return 'PROC_DISB_SUP';
  if (body.applicantInformation && body.ktpAddressDetails)
    return 'PROC_PER_INFO';
  if (path === 'inquiryloanpayment') return 'PROC_GET_INQ_PAYMENT_STATUS'
  if (body.documentDetails) return 'PROC_DOC_INFO';
  if (body.payrollDetails) return 'PROC_EMP_INFO';
  if (body.contactInformation) return 'PROC_CONC_INFO';
  return '';
};

// Determine process type for GET requests
const getGetProcessType = path => {
  if (path === 'applicationinquiry') return 'PROC_GET_APP_INQ';
  if (path === 'inquirysuplesi') return 'PROC_GET_INQ_SUP';
  return 'PROC_GET_APP';
};

export const generateHmac = (
  httpMethod,
  requestUrl,
  requestBody = {},
  isSecLoan = false
) => {
  try {
    const token = HMAC_TOKEN;
    const secretKey = HMAC_SECRET_KEY;
    const timestamp = moment().format('YYYY-MM-DD');

    let processType;

    switch (httpMethod) {
      case 'POST':
        processType = getPostProcessType(requestUrl, isSecLoan);
        break;
      case 'PUT':
        processType = getPutProcessType(requestUrl, requestBody);
        break;
      case 'GET':
        processType = getGetProcessType(requestUrl);
        break;
      default:
        processType = '';
    }

    const payload = `path=${requestUrl}&method=${httpMethod}&token=${token}&timestamp=${timestamp}&processType=${processType}`;
    const hash = CryptoJS.HmacSHA256(payload, secretKey);
    const signature = CryptoJS.enc.Base64.stringify(hash);

    return { signature, timestamp };
  } catch (error) {
    console.error('Error generating HMAC:', error);
    return null;
  }
};

export default generateHmac;
